export default "__VITE_ASSET__CaP1MJ2v__"